module.exports = __webpack_public_path__ + "static/cr-tv-app-7a30a27e1e63d03fef72ef9b04fb7d51.mp4";